import React from 'react';
import './Stats.css';

const Stats = () => {
  return (
    <section className="stats">
      <div className="container">
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">14+</div>
            <div className="stat-label">Partners</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">55+</div>
            <div className="stat-label">Projects Done</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">89+</div>
            <div className="stat-label">Happy Clients</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">150+</div>
            <div className="stat-label">Meetings</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;